<template>
	<section v-if="items.length" class="promotions align-center background-light">
		<slot name="blocks-header" />
		<div class="row">
			<div v-for="block in items.slice(0, amount)" :key="block.ID" class="columns column4">
				<div class="promotion">
					<nuxt-link class="image" :to="block.link">
						<picture>
							<source :srcset="block.imageWebp" type="image/webp" />
							<source :srcset="block.image" />
							<img :src="block.image" :alt="block.imageAlt" loading="lazy" />
						</picture>
					</nuxt-link>
					<div class="content">
						<h3>
							<nuxt-link :to="block.link">
								{{ block.header }}
							</nuxt-link>
						</h3>
						<div v-parse-links class="content-body" v-html="block.content" />
						<nuxt-link :to="block.link" class="button no-fill" target="_self">
							{{ block.button }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.row {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	justify-content: center;
	padding: 0 60px;
}

.promotions .columns {
	display: grid;
	grid-row: span 4;
	grid-template-rows: subgrid;
	padding: 0 10px;
	width: auto;
}

.promotion {
	margin: 0 auto 20px;
	box-shadow: 0 0 10px rgb(0 0 0 / 5%);
	position: relative;
	overflow: hidden;
	display: grid;
	grid-row: span 4;
	grid-template-rows: subgrid;
	width: 100%;

	.content {
		display: grid;
		grid-row: 2 / span 3;
		grid-template-rows: subgrid;
		padding: 50px;
		background-color: var(--primary-background-color);
		min-height: 320px;

		.button {
			grid-row: 3;
			line-height: 36px;
			margin-top: 10px;
			place-self: start;
		}

		h3 {
			grid-row: 1;
		}

		h3 a {
			text-decoration: none;
			color: var(--header-color);
		}

		.content-body {
			display: flow-root;
			grid-row: 2;
		}
	}

	.image {
		display: block;
		grid-row: 1;
		overflow: hidden;
		margin-bottom: 20px;
		aspect-ratio: 1;
		background-color: red;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover; /* Ensures the image covers the container */
			transition: all 0.3s ease-in-out;
		}

		&:hover img {
			transform: scale(1.03);
		}
	}
}

@media (max-width: 1480px) {
	.promotions {
		.subtitle {
			font-size: 12px !important;
		}
	}
}

@media (max-width: 1180px) {
	.row {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.promotions {
		padding: 50px 15px;
	}

	.promotion {
		.content {
			min-height: 380px;
		}
	}
}

@media (max-width: 980px) {
	.row {
		padding: 0;
	}

	.promotions .columns {
		padding: 0;
	}
}

@media (max-width: 580px) {
	.row {
		grid-template-columns: minmax(0, 1fr);
	}
}
</style>
